/**
 * SearchHospitals tool rendering component
 */

'use client';

import {
  Tool,
  ToolContent,
  ToolHeader,
  ToolInput,
} from '../elements/tool';
import { HospitalCards } from '../hospital-cards';
import type { SearchHospitalsToolPart } from './types';
import { useI18n } from '@/shared/providers/I18nProvider';

type SearchHospitalsToolProps = {
  part: SearchHospitalsToolPart;
};

export function SearchHospitalsTool({
  part,
}: SearchHospitalsToolProps) {
  const { dict } = useI18n();
  const { state, input, output } = part;

  // Output available - render HospitalCards
  if (state === 'output-available') {
    const hospitals = output?.hospitals || [];
    return <HospitalCards hospitals={hospitals} />;
  }

  // Tool error
  if (state === 'output-error') {
    return (
      <Tool>
        <ToolHeader type="searchHospitals" state={state} />
        <ToolContent>
          <div className="text-sm text-muted-foreground">
            {output?.error || dict.chat.tools.searchHospitals.error}
          </div>
        </ToolContent>
      </Tool>
    );
  }

  // Input streaming/available - show loading
  if (state === 'input-streaming' || state === 'input-available') {
    return (
      <Tool>
        <ToolHeader type="searchHospitals" state={state} />
        <ToolInput input={input} />
        <ToolContent>
          <div className="text-sm text-muted-foreground">
            {dict.chat.tools.searchHospitals.loading}
          </div>
        </ToolContent>
      </Tool>
    );
  }

  return null;
}
